import Logger from 'observability/Logger';

const LOG = new Logger('ImageUploader-utils');

export function wrapBackgroundImageUrl(url) {
    return `url("${url}")`;
}

export const ZERO_WIDTH_SPACE = String.fromCharCode('200B');

const FILE_TOO_LARGE_ERROR_MESSAGE = 'Error. Image size is too large.';
const FILE_LIMIT_MESSAGE = 'Limit is [sizeLimit]MB.';
const INVALID_TYPE_ERROR_MESSAGE = 'File type not supported!';
const SERVER_ERROR_MESSAGE = 'Server error. Please try again later.';
const FALLBACK_ERROR_MESSAGE = 'Error uploading.';

/**
 * Returns a string with the error message to show in the image uploader depending on the returned
 * error object by the Splash cake client.
 * @param {object} errorDescriptor { error, [sizeLimit] }
 */
export function getUploadErrorMessageFromErrorDescriptor(errorDescriptor) {
    errorDescriptor || (errorDescriptor = {}); // eslint-disable-line no-param-reassign
    const { sizeLimit } = errorDescriptor;

    switch (errorDescriptor.error) {
        case 'sizeLimitReached':
            return (
                FILE_TOO_LARGE_ERROR_MESSAGE +
                (sizeLimit ? ` ${FILE_LIMIT_MESSAGE.replace('[sizeLimit]', sizeLimit)}` : '')
            );
        case 'badHttpStatus':
            if (errorDescriptor.status === 413) {
                return FILE_TOO_LARGE_ERROR_MESSAGE;
            } else {
                return SERVER_ERROR_MESSAGE;
            }
        case 'invalidFileType':
            return INVALID_TYPE_ERROR_MESSAGE;
        case 'jsonParseError':
            return SERVER_ERROR_MESSAGE;
        default:
            if (__DEVELOPMENT__) {
                LOG.warn(`Error uploading image: '${errorDescriptor.error}'`);
            }

            return FALLBACK_ERROR_MESSAGE;
    }
}
